module.exports = __webpack_public_path__ + "static/media/mergedUnit.83f13fe4.svg";